import { Transform } from "../../../../geometry/transformation";
import { sharedPointMapperRef, sharedEditorCanvas, sharedRubberCanvas, DrawOptions } from "../../interface/pointMappings";
import { recalculateShape } from "../../util/shapeEdit";
//todo: check and remove if not needed...
import { /*hitStrokeCorrection,*/ strokeCorrection } from "../../util/strokeCorrection";
import { RubberDataBase, /*registerInteractionHandlers, ShapeInteractionHandlers */} from "../interactionManager";
import * as Global from "../../../../global"


export interface TextRubberData extends RubberDataBase {
    points: Point2d[],
}

export class Text {

    // draw functions
    static render(text: TextShape, isSelected: boolean, lineTypes: LineType[]) {
        const t = new Transform(text.transformation);

        const drawOptions:DrawOptions = {
            color: text?.stroke ?? Global.DEFAULT_TEXT_COLOR,
            width: text?.strokeWidth ?? Global.DEFAULT_TEXT_OUTLINE_WIDTH,
            fillColor: "blue"
        }

        const pos = t.point2d({ x: text.x, y: text.y });

        sharedEditorCanvas.current.drawText(pos, text.rot, text.fontSize, text.uiText ?? "<text>", drawOptions);

        let hotspots: Hotspot2d[] = [];

        if (isSelected) {
            hotspots.push({ x: pos.x, y: pos.y, innerId: 0, shapeId: text.id, type: text.type });
        }

        return hotspots;
    }

    static assembleShapeToInsert<L>(shape: L): L {
        return shape;
    }
    // create functions
    static create(rubberPointData: TextRubberData, settings: TextShape) : GeometricShape {
        //todo: clean this up..
        return recalculateShape(Text.assembleShapeToInsert<TextShape>({
            ...settings,
            id: 0,
            strokeWidth: strokeCorrection(settings.strokeWidth, sharedPointMapperRef.current.zoom),
            x: rubberPointData.points[0].x,
            y: rubberPointData.points[0].y,
           // uiText: "hello",
        }));
        // return recalculateShape(assembleShapeToInsert<LineShape>({
        //     ...settings,
        //     id: 0,
        //     strokeWidth: strokeCorrection(settings.strokeWidth, sharedPointMapperRef.current.zoom),
        //     hitStrokeWidth: hitStrokeCorrection(settings.hitStrokeWidth, settings.hitStrokeWidth, sharedPointMapperRef.current.zoom),
        //     closed: false,
        //     points: rubberPointData
        // }));
    }

    // rubber functions
    static rubberInputRenderer(rubberPointData: TextRubberData, cursorPosition: Point2d) {
        const dotDrawOptions: DrawOptions = {
            width: Global.DEFAULT_RUBBERLINE_DOT_PERIMETER_WIDTH,
            color: Global.DEFAULT_RUBBERLINE_DOT_PERIMETER_COLOR,
            fillColor: Global.DEFAULT_RUBBERLINE_DOT_FILL_COLOR,
        }

        rubberPointData.points.forEach(p => {
            sharedRubberCanvas.current.drawCircle(p, 5, dotDrawOptions);
        });

    }

    static rubberInputUpdater(rubberPointData: TextRubberData, cursorPosition: Point2d) : TextRubberData {
        rubberPointData.points = [...rubberPointData.points, sharedPointMapperRef.current.screenToWorld(cursorPosition)];
        rubberPointData.finished = true;
        return rubberPointData;
    }

    static rubberInputResetter(rubberPointData: TextRubberData) {
        rubberPointData.finished = false;
        rubberPointData.points = [];
        return rubberPointData;
    }

}